module.exports = __webpack_public_path__ + "static/images/finance-5.e63ca8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-5.png
// module id = Soi7
// module chunks = 8